import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'youtubeEmbed'})
export class YoutubeEmbedPipe implements PipeTransform {
  constructor() {}

  transform(url: any): string {
    return '//www.youtube.com/embed/' + this.getId(url);
  }

  getId(url) {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = url.match(regExp);

    if (match && match[2].length == 11) {
        return match[2];
    } else {
        return 'error';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/@core/pipes/youtube-embed.pipe.ts